import { useEffect, useState } from 'react';

const PREFIX = 'ui:';

// Drop-in replacement for useState that survives a page reload (backed by
// localStorage, not sessionStorage - it's meant to still be there if you
// close the browser and come back). Deliberately opt-in, not a blanket
// "persist everything" mechanism - only use this for genuine view
// preferences (which tab is active, is this panel expanded), never for
// operational state (saving/loading/error) or "is this modal open" (which
// could reopen pointing at data that's since changed or been deleted).
//
// `key` must be unique per rendered instance, not just per component - two
// mounts of the same component (e.g. one ApiUsageChart per AI provider)
// need distinct keys (e.g. include the provider) or they'll overwrite each
// other's stored value.
export default function usePersistedState(key, defaultValue) {
   const [value, setValue] = useState(() => {
      try {
         const stored = localStorage.getItem(PREFIX + key);
         return stored !== null ? JSON.parse(stored) : defaultValue;
      } catch (e) {
         return defaultValue;
      }
   });

   useEffect(() => {
      try {
         localStorage.setItem(PREFIX + key, JSON.stringify(value));
      } catch (e) {
         // localStorage full/unavailable (e.g. private browsing) - the view
         // preference just won't survive a reload this time, nothing to do.
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [key, value]);

   return [value, setValue];
}
